import React from "react";
import { useAudioPlayer } from "../context/AudioPlayerContext";
import { useNavigate } from "react-router-dom";
import { Play, Pause, X } from "lucide-react";
import { Slider } from "./ui/slider";

const fmt = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60).toString().padStart(2, "0");
  return `${m}:${sec}`;
};

const StickyAudioBar = () => {
  const { current, isPlaying, progress, duration, togglePlay, seek, close, hasTrack } = useAudioPlayer();
  const navigate = useNavigate();

  if (!hasTrack) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-[60] bg-neutral-900 text-neutral-100 shadow-[0_-8px_30px_rgba(0,0,0,0.25)]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-3 flex items-center gap-4">
        {/* Track info */}
        <button
          onClick={() => navigate(`/episode/${current.id}`)}
          className="flex items-center gap-3 min-w-0 shrink-0 w-[42%] md:w-72 text-left group"
        >
          <img src={current.thumbnail} alt={current.title} className="w-12 h-12 rounded object-cover shrink-0" />
          <div className="min-w-0">
            <p className="font-display text-base leading-tight truncate group-hover:opacity-80 transition-opacity">
              {current.title}
            </p>
            <p className="font-sans-ui text-xs text-neutral-400 truncate">{current.guest}</p>
          </div>
        </button>

        {/* Play / pause */}
        <button
          onClick={togglePlay}
          aria-label={isPlaying ? "Pause" : "Play"}
          className="w-11 h-11 rounded-full bg-white text-neutral-900 flex items-center justify-center shrink-0 hover:scale-105 transition-transform"
        >
          {isPlaying ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" className="ml-0.5" />}
        </button>

        {/* Seek */}
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <span className="font-sans-ui text-xs text-neutral-400 tabular-nums w-10 text-right hidden sm:block">
            {fmt(progress)}
          </span>
          <Slider
            value={[progress]}
            max={duration || 100}
            step={1}
            onValueChange={([v]) => seek(v)}
            className="flex-1"
          />
          <span className="font-sans-ui text-xs text-neutral-400 tabular-nums w-10 hidden sm:block">
            {fmt(duration)}
          </span>
        </div>

        {/* Close */}
        <button
          onClick={close}
          aria-label="Close player"
          className="w-9 h-9 rounded-full flex items-center justify-center text-neutral-400 hover:text-white hover:bg-neutral-800 transition-colors shrink-0"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default StickyAudioBar;
